import { Doughnut } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  useTheme,
} from '@mui/material';
import LoadingProgress from '../LoadingProgress';
// import { LaptopMac, Phone, Tablet } from '@mui/icons-material';

function OrderReportByStatus(props) {
  const theme = useTheme();
  const orderState = useSelector((state) => state.orderReducer);
  const { orderReportStatus, loadingOrders } = orderState;
  // const { delivered, inTransit, canceled } = orderReportStatus;

  const data = orderReportStatus ? {
    datasets: [
      {
        data: [
          orderReportStatus.delivered.value,
          orderReportStatus.inTransit.value,
          orderReportStatus.canceled.value],
        backgroundColor: [
          colors.green[500],
          colors.blue[600],
          colors.red[600],
        ],
        borderWidth: 1,
        borderColor: colors.common.white,
        hoverBorderColor: colors.common.white,
      },
    ],
    labels: [
      orderReportStatus.delivered.title,
      orderReportStatus.inTransit.title,
      orderReportStatus.canceled.title,
    ],
  } : { datasets: [] };

  const options = {
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary,
    },
  };

  return (
    <Card {...props}>
      <CardHeader title="Orders by Status" />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 300,
            position: 'relative',
          }}
        >
          {loadingOrders ? <LoadingProgress /> : (
            <Doughnut
              data={data}
              options={options}
            />
          )}

        </Box>

      </CardContent>
    </Card>
  );
}

export default OrderReportByStatus;
